import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_admin/_legacy/accounts/combine")({
  beforeLoad: () => {
    throw redirect({to: "/admins/accounts/combine", replace: true});
  },
});
